// extracted by mini-css-extract-plugin
module.exports = {"envelope-animation":"global_envelope-animation__3VTVe"};